export const summaryMessage = {
  exportFailed: 'エクスポートに失敗しました。',
}
